class ServerError extends Error {
    constructor(details, statusText, defaultMessage, url) {
        const message = details?.Message ?? statusText;
        super(message);
    
        if (Error.captureStackTrace) {
          Error.captureStackTrace(this, ServerError);
        }
  
      this.title = "Server Error";
      this.statusCode = details?.StatusCode;
      this.details = details?.Details ?? details;
      this.defaultMessage = defaultMessage;
      this.url = url;
    }
  }
  
  export default ServerError;
  